import { AxiosError } from 'axios';

export const shouldRetry = (
  error: AxiosError,
  retriesLeft: number
): boolean => {
  const { response } = error;
  const is401 = response?.status === 401;

  return is401 && retriesLeft > 0;
};
